import dayjs from 'dayjs';
import { isNil } from '../../../helpers/utils';

export const NOT_AVAILABLE = 'n/a';

export function formatValue(info) {
  if (typeof info === 'boolean' || typeof info === 'number') {
    return info;
  }
  if (Array.isArray(info)) {
    if (info.length === 0) {
      return NOT_AVAILABLE;
    }
    if (info.length === 1) {
      return info[0];
    }
    return `multiple-${info.join(',')}`;
  }
  if (isNil(info) || info === '') {
    return NOT_AVAILABLE;
  }
  return info;
}

export function formatValueArrays(info) {
  if (typeof info === 'boolean' || typeof info === 'number') {
    return info;
  }
  if (Array.isArray(info)) {
    if (info.length === 0) {
      return NOT_AVAILABLE;
    }
    if (info.length === 1) {
      return info[0];
    }
    if (info.length > 1) {
      return 'MULTIPLE';
    }
  }
  if (isNil(info) || info === '') {
    return NOT_AVAILABLE;
  }
  return info;
}

export function formatValueStringEmpty(info) {
  const newInfo = formatValue(info);
  if (newInfo === NOT_AVAILABLE || newInfo === 'ALL') {
    return '';
  }
  return newInfo;
}

export function formatDate(value, format = undefined) {
  let date = value;
  if (typeof value === 'number') {
    date = dayjs().add(value, 'day');
  } else if (!date) {
    return NOT_AVAILABLE;
  } else if (typeof value !== 'object' || value instanceof Date || !date.format) {
    date = dayjs(value);
  }
  if (format !== undefined) {
    return date.format(format);
  }
  return date.format('YYYY-MM-DD');
}

export const EMPTY_OBJECT = {};
